import React, { useState, useEffect } from "react";
import apiService from "./services/api.service";
import ImageGallery from "./imageGallery";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col, Modal, Button } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { useForm } from "react-hook-form";
import StorageSessionService from "./services/storage.service";
import FilterDropdownComponent from "./FilterDropdown";
import { resetCart } from "./Redux/shoppingCartReducer";
import { setWorkers } from "./Redux/companyReducer";
import OpenValueProduct from "./OpenValueProduct";
import VirtualTourModal from "./VirtualTourModal";
import Product from "./Product";
import Company from "./companyComponents/Company";
import { eventService } from "./services/event.service";



function ProductsListComponent(props) {
  const [products, setProducts] = useState([]);
  const [productsFiltered, setProductsFiltered] = useState([])
  const [lang, setLang] = useState("");
  const [errorMsg, seterrorMsg] = useState([]);
  const LastfreePriceChosenKey = 'LastfreePriceChosen';
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch()
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  let propertyId = new URLSearchParams(location.search).get("propid") || 0;
  const productBlockingIdentifier = window.sessionStorage.getItem("productBlockingIdentifier");
  const sessionService = new StorageSessionService();
  const companyUser = useSelector((state) => state.company.companyUser)
  const company = useSelector((state) => state.company.company)
  const [virtualTourURL, setVirtualTourURL] = useState("")
  const [showVirtualTourModal, setShowVirtualTourModal] = useState(false);
  const handleShow = (url) => {
    setVirtualTourURL(url)
    setShowVirtualTourModal(true);
  }
  const handleClose = () => setShowVirtualTourModal(false);
  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  //update data layer
  useEffect(() => {
    if (products && products.length) {      
      eventService.viewList(products);
    }
  }, [products])


  useEffect(() => {
    sessionStorage.removeItem("viewProduct");
    setLang(new URLSearchParams(location.search).get("lang") || "en");
    if (productBlockingIdentifier) {
      unblockProduct(productBlockingIdentifier);
    }
    sessionService.removeSessionStorage(LastfreePriceChosenKey).then(r => {
      seterrorMsg([]);
      getProducts();
    });
  }, [companyUser, company]);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  useEffect(() => {
    sessionStorage.removeItem("products")
    dispatch(resetCart())
    dispatch(setWorkers([]))
  }, [])

  const unblockProduct = (productBlockingIdentifier) => {
    sessionStorage.removeItem('productBlockingIdentifier');
    sessionStorage.removeItem('productBlockingIdentifierTime');
    sessionStorage.removeItem('products');

    apiService.unblockProduct(productBlockingIdentifier).then((response) => { }, (error) => { });
  };

  const getProducts = (_properyId) => {
    _properyId = _properyId || propertyId;
    if (companyUser && company) {
      apiService.getCompanyProducts(company.companyId).then(
        (response) => {
          var allproducts = response.data.data;
          allproducts = [...allproducts].sort((a, b) => a.sortOrder - b.sortOrder);
          setProducts(allproducts);
          setProductsFiltered(allproducts)
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          if (_content.indexOf("401") > -1) {
            sessionStorage.removeItem("token");
          }
        }
      )
    } else {
      apiService.getProducts(chainId, _properyId, true).then(
        (response) => {
          var allproducts = response.data.data;
          allproducts = [...allproducts].sort((a, b) => a.sortOrder - b.sortOrder);
          setProducts(allproducts);
          setProductsFiltered(allproducts)
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          if (_content.indexOf("401") > -1) {
            localStorage.removeItem("token");
            // getProducts();
          }
        }
      )
    }
  }

  const getProductTranslations = (prod) => {
    if (prod.translations) {
      let ProductTranslations = prod.translations.filter((p) => { return p.languageIsoCode == lang && p.propductId == prod.propductId });
      return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
    }
    return {};
  };

  const submitForm = (data, productId, product = null) => {
    let freePrice = data["freePriceInput" + productId];
    if (data["productMinimumPrice"] && data["productMaximumPrice"] && data["productMinimumPrice"] === data["productMaximumPrice"]) {
      freePrice = data["productMinimumPrice"];
    }
    product.productPrice = freePrice;
    selectProd(product)
    if ((freePrice && parseInt(freePrice) > 0)) {
      if (data["productMinimumPrice" + productId] && data["productMaximumPrice" + productId]) {
        if (parseInt(freePrice) >= parseInt(data["productMinimumPrice" + productId]) && parseInt(freePrice) <= parseInt(data["productMaximumPrice" + productId])) {
          sessionService.removeSessionStorage(LastfreePriceChosenKey).then(r => {
            sessionService.setSessionStorage("LastfreePriceChosen", freePrice).then(res => {
              history.push(`/product?chainid=${chainId}&pid=${productId}&lang=${lang}`);
              seterrorMsg([]);
            }).catch(err => {
              console.error(err);
            });
          });
        }
        else if (data["productMinimumPrice" + productId] && data["productMaximumPrice" + productId]) {
          errorMsg[productId] = t("insertPrice") + " " + t("between") + " " + data["productMinimumPrice" + productId] + "-" + data["productMaximumPrice" + productId];
          seterrorMsg(errorMsg);
        }
      }
      else if (data["productMinimumPrice" + productId] && !data["productMaximumPrice" + productId]) {
        if (parseInt(freePrice) >= parseInt(data["productMinimumPrice" + productId])) {
          sessionService.removeSessionStorage(LastfreePriceChosenKey).then(r => {
            sessionService.setSessionStorage(LastfreePriceChosenKey, freePrice).then(_ => {
              history.push(`/product?chainid=${chainId}&pid=${productId}&lang=${lang}`);
              seterrorMsg([]);
            })
          });
        }
        else {
          errorMsg[productId] = t("insertPrice") + " " + t("from") + " " + data["productMinimumPrice" + productId];
          seterrorMsg(errorMsg);
        }
      }
      else if (!data["productMinimumPrice" + productId] && !data["productMaximumPrice" + productId]) {
        sessionService.removeSessionStorage(LastfreePriceChosenKey).then(_ => {
          sessionService.setSessionStorage(LastfreePriceChosenKey, freePrice).then(_ => {
            history.push(`/product?chainid=${chainId}&pid=${productId}&lang=${lang}`);
            seterrorMsg([]);
          });
        });
      }
    }
    else {
      errorMsg[productId] = t("priceMoreThen").replace("[0]", "0");
      seterrorMsg(errorMsg);
    }
  };

  const selectProd = (product, link) => {
    if (!product.isOpenValue) {
      history.push(link);
    }
    sessionStorage.setItem("viewProduct", JSON.stringify(product));
    eventService.selectItem(product);
  }

  const getProductLabel = (p) => {
    if (p.translations) {
      return p.translations.map((t, idx) => {
        if (t.languageIsoCode === lang) {
          if (t.label && t.label.length) {
            return <h5 key={idx} className="product-label">{t.label}</h5>
          }
        }
      })
    }
  }

  const virtualTourLogo = (virtualTourURL) => {
    return (
      <a role="button" onClick={() => handleShow(virtualTourURL)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="69" height="61" viewBox="0 0 69 61" fill="none">
          <rect width="69" height="61" rx="3" fill="white" fillOpacity="0.6" />
          <path d="M53.3097 26.1886C52.6866 25.8128 51.8761 26.012 51.4992 26.6328C51.1224 27.2536 51.3219 28.0615 51.9449 28.437C53.5045 29.3771 54.3633 30.4005 54.3633 31.3188C54.3633 32.2903 53.415 33.3661 51.6933 34.348C49.7 35.4848 46.8546 36.4016 43.4648 36.9994C42.7479 37.1258 42.2694 37.8076 42.3964 38.5221C42.5095 39.1592 43.0656 39.6072 43.693 39.6072C43.7692 39.6072 43.8466 39.6006 43.9243 39.5869C52.1119 38.1431 57 35.0523 57 31.3188C57 28.9174 54.9932 27.2035 53.3097 26.1886Z" fill="black" />
          <path d="M35.291 38.0072L31.7754 35.3794C31.1929 34.9441 30.3666 35.0617 29.9297 35.6422C29.4928 36.2227 29.6109 37.0462 30.1934 37.4816L30.3426 37.5932C26.4296 37.3038 22.8441 36.6058 19.9762 35.5578C16.6328 34.3362 14.6367 32.7514 14.6367 31.3188C14.6367 30.4006 15.4956 29.3771 17.0553 28.437C17.6783 28.0614 17.8778 27.2536 17.501 26.6328C17.124 26.012 16.3137 25.813 15.6905 26.1886C14.007 27.2034 12 28.9173 12 31.3188C12 33.116 13.1525 34.4889 14.1194 35.3242C15.3075 36.3505 16.9726 37.2591 19.0685 38.025C22.2951 39.2039 26.3334 39.9703 30.7063 40.2515L30.1934 40.6349C29.6109 41.0704 29.4928 41.8939 29.9297 42.4744C30.1887 42.8186 30.5846 43 30.9854 43C31.2607 43 31.5383 42.9143 31.7754 42.7371L35.291 40.1094C35.623 39.8612 35.8184 39.4718 35.8184 39.0583C35.8184 38.6448 35.623 38.2553 35.291 38.0072Z" fill="black" />
          <path d="M23.6512 27.3729L33.8552 33.0752C34.0555 33.1871 34.2777 33.2431 34.5 33.2431C34.7223 33.2431 34.9446 33.1871 35.1448 33.0752L45.3488 27.3729C45.7648 27.1405 46.0224 26.7022 46.0224 26.227V13.0161C46.0224 12.5408 45.7648 12.1025 45.3488 11.8701L35.1448 6.16791C34.7442 5.94403 34.2558 5.94403 33.8552 6.16791L23.6512 11.8701C23.2352 12.1026 22.9776 12.5408 22.9776 13.0161V26.227C22.9776 26.7022 23.2352 27.1405 23.6512 27.3729ZM25.6143 15.2592L33.1816 19.4879V29.6861L25.6143 25.4574V15.2592ZM35.8184 29.6861V19.4879L43.3857 15.2592V25.4574L35.8184 29.6861ZM34.5 8.82028L42.0084 13.0161L34.5 17.2119L26.9916 13.0161L34.5 8.82028Z" fill="black" />
          <g clipPath="url(#clip0_10296_9302)">
            <path d="M45.2615 44.1262C44.2331 44.1262 43.3964 44.9629 43.3964 45.9913C43.3964 47.0197 44.2331 47.8563 45.2615 47.8563C46.2899 47.8563 47.1265 47.0197 47.1265 45.9913C47.1265 44.9629 46.2899 44.1262 45.2615 44.1262ZM45.2615 46.45C45.0085 46.45 44.8027 46.2442 44.8027 45.9912C44.8027 45.7382 45.0085 45.5324 45.2615 45.5324C45.5144 45.5324 45.7203 45.7382 45.7203 45.9912C45.7203 46.2442 45.5144 46.45 45.2615 46.45Z" fill="black" />
            <path d="M26.7189 54.5171C28.4472 54.5171 29.6583 53.4119 29.6583 51.8129C29.6583 50.4373 28.7647 49.4143 27.4949 49.238L29.2467 47.0863V45.9341H24.3791V47.3215H27.2832L25.5314 49.4966L26.1898 50.4843C26.3426 50.4255 26.519 50.402 26.6954 50.402C27.6242 50.402 28.2709 50.9781 28.2709 51.8129C28.2709 52.6124 27.6477 53.165 26.7541 53.165C26.0017 53.165 25.402 52.7065 25.1434 51.9422L23.8735 52.5066C24.3086 53.7411 25.402 54.5171 26.7189 54.5171Z" fill="black" />
            <path d="M33.1387 54.5171C34.7965 54.5171 36.1251 53.2238 36.1251 51.5777C36.1251 50.0257 34.9494 48.7089 33.3621 48.7089C33.268 48.7089 33.174 48.7089 33.0799 48.7206L34.773 45.9341H33.1622L30.6461 49.967C30.3404 50.4608 30.164 51.0369 30.164 51.6365C30.164 53.2826 31.4926 54.5171 33.1387 54.5171ZM31.5514 51.5895C31.5514 50.743 32.2451 50.061 33.1387 50.061C34.0205 50.061 34.7142 50.7312 34.7142 51.5895C34.7142 52.4478 34.0205 53.1297 33.1387 53.1297C32.2451 53.1297 31.5514 52.4478 31.5514 51.5895Z" fill="black" />
            <path d="M39.9648 54.5171C42.0576 54.5171 43.3039 52.8828 43.3039 50.1668C43.3039 47.4508 42.0576 45.8165 39.9648 45.8165C37.8837 45.8165 36.6256 47.4508 36.6256 50.1668C36.6256 52.8828 37.8837 54.5171 39.9648 54.5171ZM38.013 50.1668C38.013 48.2151 38.6832 47.2039 39.9648 47.2039C41.2464 47.2039 41.9165 48.2151 41.9165 50.1668C41.9165 52.1186 41.2464 53.1297 39.9648 53.1297C38.6832 53.1297 38.013 52.1186 38.013 50.1668Z" fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_10296_9302">
              <rect width="25" height="11" fill="white" transform="translate(22 44)" />
            </clipPath>
          </defs>
        </svg>
      </a>
    )
  }

  return (
    <div className="product-list-wrap">
      <div className="header">
        <FilterDropdownComponent
          lang={lang}
          chainId={chainId}
          products={products}
          setProducts={setProducts}
          productsFiltered={productsFiltered}
          setProductsFiltered={setProductsFiltered}
        />
        <Company />
      </div>
      <Row>
        {productsFiltered.map((prod, idx) => {
          return (
            <Col key={prod.productId} lg={4} className="box-wrap">
              {showVirtualTourModal &&
                <VirtualTourModal
                  handleClose={handleClose}
                  virtualTourURL={virtualTourURL}
                  showVirtualTourModal={showVirtualTourModal}
                />
              }
              <div className="product box">
                {getProductLabel(prod)}
                <ImageGallery product={prod} images={prod.images} autoSlide="false" />
                {prod.virtualTourURL &&
                  <div className="virtual-tour-logo">
                    {virtualTourLogo(prod.virtualTourURL)}
                  </div>
                }
                {!prod.isOpenValue ?
                  <Product
                    idx={idx}
                    lang={lang}
                    prod={prod}
                    chainId={chainId}
                    selectProd={selectProd}
                    companyUser={companyUser}
                    getProductTranslations={getProductTranslations}
                  />
                  :
                  <OpenValueProduct
                    idx={idx}
                    prod={prod}
                    lang={lang}
                    chainId={chainId}
                    errorMsg={errorMsg}
                    register={register}
                    selectProd={selectProd}
                    submitForm={submitForm}
                    handleSubmit={handleSubmit}
                    getProductTranslations={getProductTranslations}
                  />
                }
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

export default ProductsListComponent;
